import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from 'kea-resource';

import { ViajeZEApp } from "./viajezeapp";

const controller = rpcController("ViajesZE");

export const ViajeZE = cacheResource({
    /**Crea un viaje de ZE y devuelve el id */
    CrearViaje: async (model: models.NuevoViajeZEModel): Promise<number> => await controller('CrearViaje', {}, model),

    /**Crea un viaje de ZE y devuelve el id */
    ObtenerAcusesViaje: async (model: models.NuevoViajeZEModel): Promise<models.RecordatorioAcuse[]> => await controller('ObtenerAcusesViaje', {}, model),

    /**Le da salida/inicio a un viaje de ZE, este debe de estar iniciado en la app movil */
    DarSalidaViaje: async (idViaje: number): Promise<void> => await controller('DarSalidaViaje', { idViaje }),

    /**Marca como finalizado pero pendiente de descarga un viaje, este paso se hace despues de que el chofer lo finalizó desde su app  */
    MarcarFinalizadoPendienteDescarga: async (idViaje: number): Promise<void> => await controller('MarcarFinalizadoPendienteDescarga', { idViaje }),

    /**Marca un viaje como pendiente de verificación, este paso se hace despues de descargar por completo el camión de ZE */
    MarcarPendienteVerificacion: async (idViaje: number): Promise<void> => await controller('MarcarPendienteVerificacion', { idViaje }),

    /**Marca un viaje como finalizado */
    FinalizarViaje: async (idViaje: number): Promise<void> => await controller('FinalizarViaje', { idViaje }),

    /**
     * Cancela un viaje de ZE
     * @param idViaje 
     */
    CancelarViaje: async (idViaje: number): Promise<void> => await controller('CancelarViaje', { idViaje }),

    /**Consulta un listado de viajes */
    ConsultarViajes: async (filtro: models.FiltroViajeZE): Promise<models.ViajeZEDto[]> => await controller('ConsultarViajes', {}, filtro),

    /**Para cierto usuario obtiene un listado con los posibles viajes que el podria iniciar en su dispositivo */
    ObtenerPosiblesInicioApp: async (idUsuario: number): Promise<models.ViajeZEDto[]> => await controller('ObtenerPosiblesInicioApp', { idUsuario }),

    /**Imprime los acuses internos de las guias incluidas en este viaje */
    ReporteAcusesInternos: async (idViajeZE: number): Promise<string> => await controller('ReporteAcusesInternos', { idViajeZE }),

    /**Obtiene el DTO de un viaje de ZE */
    GetViaje: async (idViajeZE: number): Promise<models.ViajeZEDto> => await controller('GetViaje', { idViajeZE }),

    /**Obtiene un listado con las guias del viaje */
    GetGuiasEnViaje: async (idViajeZE: number): Promise<models.GuiaDTO[]> => await controller('GetGuiasEnViaje', { idViajeZE }),

    /**Obtiene el reporte de manifiesto de viaje de ZE */
    ReporteManifiesto: async (idViajeZE: number, esDeSalida: boolean): Promise<string> => await controller('ReporteManifiesto', { idViajeZE, esDeSalida }),

    /**Obtiene el modelo de verificación de un viaje de ZE. Este modelo contiene la información para que el usuario verifique el viaje de ZE */
    ObtenerModeloVerificacionViaje: async (idViajeZE: number): Promise<models.VerificacionViajeZEDto> => await controller('ObtenerModeloVerificacionViaje', { idViajeZE }),

    /**Crea las guias de los acuses entregados en un viaje de ZE. Devuelve la cantidad de guias de acuse que se generaron */
    CrearGuiasAcuse: async (idViaje: number): Promise<number> => await controller('CrearGuiasAcuse', { idViaje }),
}, {
        ConsultarViajes: true,
        GetGuiasEnViaje: true
    }, {
        CrearViaje: true,
        MarcarFinalizadoPendienteDescarga: true,
        MarcarPendienteVerificacion: true,
        FinalizarViaje: true,
        DarSalidaViaje: true,
        CancelarViaje: true
    });


// WEBPACK FOOTER //
// ./app/resources/items/viajeze.tsx